<button [@changeBackgroundColorMenu]="opened ? true : false" (click)="openOrCloseMenu()"><img src="assets/images/icons/menu.svg" alt="Menu Lateral"></button>
<div class="menu" [@openClose]="opened ? true : false">
    <div class="nav">
        <p><a routerLink="/inicio" fragment="comdica">O que é o COMDICA?</a></p> <hr>
        <!-- <p><a href="#">Fotos</a></p> <hr>
        <p><a href="#">Eventos</a></p> <hr> -->
        <p><a routerLink="/legislacao">Legislação</a></p> <hr>
        <p><a routerLink="/prestacao-contas">Prestação de contas</a></p> <hr>
        <p><a routerLink="/calendario-reunioes">Calendário </a></p>
    </div>
</div>

<div class="menu_expanded" *ngIf="isHomePage">
    <p><a (click)="navigateAnchor(0)">O que é o COMDICA?</a></p>
    <!-- <p><a href="#">Fotos</a></p>
    <p><a href="#">Eventos</a></p> -->
    <p><a (click)="navigateAnchor(1)">Legislação</a></p>
    <p><a (click)="navigateAnchor(2)">Prestação de contas</a></p>
    <p><a (click)="navigateAnchor(3)">Calendário</a></p>
    <p><a (click)="navigateAnchor(4)">Contato</a></p>
</div>

<div class="menu_expanded" *ngIf="!isHomePage">
    <p><a (click)="navigateTo(0)">O que é o COMDICA?</a></p>
    <p><a (click)="navigateTo(1)">Legislação</a></p>
    <p><a (click)="navigateTo(2)">Prestação de contas</a></p>
    <p><a (click)="navigateTo(3)">Calendário</a></p>
    <p><a (click)="navigateTo(4)">Contato</a></p>
</div>
